if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (window.__lioraProductAddBusy) return;
        window.__lioraProductAddBusy = true;
        const lioraSubmitStartedAt = Date.now();

        const sectionRoot =
          document.getElementById(`MainProduct-${this.dataset.sectionId}`) ||
          this.closest('product-info') ||
          this.closest('section') ||
          document;
        const selectedBundle = sectionRoot?.querySelector(
          '[data-liora-bundle-picker] input[type="radio"]:checked[data-liora-bundle-variant-id]'
        );
        if (selectedBundle?.dataset.lioraBundleVariantId) {
          this.variantIdInput.value = selectedBundle.dataset.lioraBundleVariantId;
          this.variantIdInput.disabled = false;

          let quantityInput = this.form.querySelector('input[name="quantity"]');
          if (!quantityInput) {
            quantityInput = document.createElement('input');
            quantityInput.type = 'hidden';
            quantityInput.name = 'quantity';
            this.form.appendChild(quantityInput);
          }
          quantityInput.value = '1';
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.setAttribute('aria-busy', 'true');
        this.submitButton.setAttribute('disabled', 'disabled');
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');
        this.setAllAddButtonsBusy(true, this.submitButton);

        const selectedBundleVariantId = selectedBundle?.dataset.lioraBundleVariantId;
        const bundleVariantIds = selectedBundleVariantId
          ? Array.from(
              sectionRoot.querySelectorAll('[data-liora-bundle-picker] input[data-liora-bundle-variant-id]')
            )
              .map((input) => input.dataset.lioraBundleVariantId)
              .filter(Boolean)
          : [];
        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';

        let variantId = selectedBundleVariantId || this.variantIdInput.value;
        let quantity = 1;

        const prepareBundleUpdate = selectedBundleVariantId
          ? fetch(`${window.Shopify?.routes?.root || '/'}cart.js`, {
              headers: {
                'X-Requested-With': 'XMLHttpRequest',
                Accept: 'application/json',
              },
            })
              .then((response) => (response.ok ? response.json() : { items: [] }))
              .then((cartState) => {
                const existingSelectedItem = (cartState.items || []).find(
                  (item) => String(item.variant_id) === String(selectedBundleVariantId)
                );
                const nextSelectedQuantity = (Number(existingSelectedItem?.quantity) || 0) + 1;
                const body = new URLSearchParams();
                body.set(`updates[${selectedBundleVariantId}]`, String(nextSelectedQuantity));
                if (this.cart) {
                  body.set(
                    'sections',
                    this.cart.getSectionsToRender().map((section) => section.id).join(',')
                  );
                  body.set('sections_url', window.location.pathname);
                  this.cart.setActiveElement(document.activeElement);
                }
                config.body = body.toString();
              })
          : Promise.resolve();

        if (selectedBundleVariantId) {
          config.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=UTF-8';
        } else {
          delete config.headers['Content-Type'];
          const formData = new FormData(this.form);
          if (this.cart) {
            formData.append(
              'sections',
              this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
            this.cart.setActiveElement(document.activeElement);
          }
          config.body = formData;
          variantId = formData.get('id');
          quantity = parseInt(formData.get('quantity')) || 1;
        }

        const linesUpdateDeferred = selectedBundleVariantId
          ? null
          : this.createCartLinesUpdateEvent(variantId, quantity);
        const shopRoot = window.Shopify?.routes?.root || '/';
        const clearBundleItems = Promise.resolve();
        const cartAddUrl = selectedBundleVariantId ? `${shopRoot}cart/update.js` : `${shopRoot}cart/add.js`;

        clearBundleItems
          .then(() => prepareBundleUpdate)
          .then(() => fetch(cartAddUrl, config))
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);
              this.dispatchCartErrorEvent(response.description || response.message, 'INVALID');
              linesUpdateDeferred?.reject(new Error(response.description || response.message));
              this.error = true;
              return;
            } else if (!this.cart) {
              this.resolveCartLinesUpdate(linesUpdateDeferred);
              window.location = window.routes.cart_url;
              return;
            }

            this.resolveCartLinesUpdate(linesUpdateDeferred);

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: variantId,
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
            this.dispatchCartErrorEvent(e.message || 'Network error', 'SERVICE_UNAVAILABLE');
            linesUpdateDeferred?.reject(e);
          })
          .finally(() => {
            const releaseLoading = () => {
              window.__lioraProductAddBusy = false;
              this.setAllAddButtonsBusy(false, this.submitButton);
              this.submitButton.classList.remove('loading');
              if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
              this.submitButton.removeAttribute('aria-disabled');
              this.submitButton.removeAttribute('aria-busy');
              this.submitButton.removeAttribute('disabled');
              if (this.submitButtonText) this.submitButtonText.classList.remove('hidden');
              this.submitButton.querySelector('.sold-out-message')?.classList.add('hidden');
              this.querySelector('.loading__spinner')?.classList.add('hidden');

              CartPerformance.measureFromEvent("add:user-action", evt);
            };
            window.setTimeout(releaseLoading, Math.max(0, 550 - (Date.now() - lioraSubmitStartedAt)));
          });
      }

      setAllAddButtonsBusy(isBusy, activeButton) {
        document.querySelectorAll('product-form [type="submit"]').forEach((button) => {
          if (button === activeButton) return;
          if (isBusy) {
            if (!button.disabled) button.dataset.lioraRestoreDisabled = 'true';
            button.setAttribute('aria-disabled', 'true');
            button.setAttribute('disabled', 'disabled');
          } else if (button.dataset.lioraRestoreDisabled === 'true') {
            button.removeAttribute('aria-disabled');
            button.removeAttribute('disabled');
            delete button.dataset.lioraRestoreDisabled;
          }
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      createCartLinesUpdateEvent(variantId, quantity) {
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return null;

        const deferred = CartLinesUpdateEvent.createPromise();
        this.dispatchEvent(
          new CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: [{ merchandiseId: variantId, quantity }],
            promise: deferred.promise,
          })
        );
        return deferred;
      }

      resolveCartLinesUpdate(deferred) {
        if (!deferred) return;
        const { CartLinesUpdateEvent } = window.StandardEvents || {};
        if (!CartLinesUpdateEvent) return;

        const pendingCartDataPromise = typeof CartItems !== 'undefined'
          ? CartItems.fetchCartData()
          : fetch(`${routes.cart_url}.json`).then((response) => response.json());

        pendingCartDataPromise
          .then((cart) => {
            if (!cart?.currency) return deferred.reject(new Error('Missing currency in cart response'));
            deferred.resolve({ cart: CartLinesUpdateEvent.createCartFromAjaxResponse(cart) });
          })
          .catch((e) => deferred.reject(e));
      }

      dispatchCartErrorEvent(message, code) {
        const { CartErrorEvent } = window.StandardEvents || {};
        if (!CartErrorEvent) return;
        this.dispatchEvent(new CartErrorEvent({ error: message, code }));
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
